import { clsx } from 'clsx';

import { CloseIcon } from '#icons/CloseIcon';

import { Button } from '../Button';
import { IconButton } from '../IconButton/IconButton';
import { variantToBackgroundColorMap, variantToColorMap, variantToIconMapping } from './consts';
import type { ToastProps } from './types';

export const Toast = ({ content, variant = 'info', autoClose, onClose, action }: ToastProps) => {
  const Icon = variantToIconMapping[variant];

  return (
    <div
      className={clsx(
        'ods-flex ods-flex-col ods-rounded-4 ods-shadow-medium  ods-pt-2 ods-pr-2 ods-pb-6 ods-pl-4 ods-w-80 ods-min-h-16',
        variantToBackgroundColorMap[variant],
      )}
    >
      {autoClose === false && (
        <div className="ods-flex ods-self-end">
          <IconButton
            variant="ghost"
            onClick={onClose}
            icon={CloseIcon}
            iconProps={{ size: 16, className: variantToColorMap[variant] }}
          />
        </div>
      )}
      <div className="ods-flex ods-gap-2 ods-items-start">
        {Icon && <Icon className={clsx('ods-flex-shrink-0', variantToColorMap[variant])} />}
        <div className="ods-flex ods-flex-col ods-gap-2 ods-items-start">
          <div className={clsx('ods-text-base', variantToColorMap[variant])}>{content}</div>
          {action && (
            <Button
              label={action.label}
              onClick={action.onClick}
              variant="ghost"
              className={variantToColorMap[variant]}
            />
          )}
        </div>
      </div>
    </div>
  );
};
